/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */


import { DeliveryAddress } from './models/delivery-address';
import { PointOnMap } from './models/point-on-map';
import i18n from './getText';

export function transformImgUrl(imageUrl: string = '', size: number = 1): string {
  return imageUrl.replace('image/upload/', `image/upload/h_${60 * size},c_fit/`);
}


export function gPlaceToDeliveryAddress(place, point: PointOnMap): DeliveryAddress {
  const addressComponents = place['address_components'];

  const componentForm = {
    street_number: 'short_name',
    route: 'short_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
    premise: 'short_name',
    sublocality: 'short_name',
    postal_code_suffix: 'short_name',
  };

  const dropOffSource = {
    street_number: null,
    premise: null,
    sublocality: null,
    route: null,
    locality: null,
    administrative_area_level_1: null,
    administrative_area_level_2: null,
    country: null,
    postal_code: null,
    postal_code_suffix: null
  };

  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < addressComponents.length; i++) {
    const addressType = addressComponents[i].types.find(t => componentForm[t]) || addressComponents[i].types[0];

    if (componentForm[addressType]) {
      dropOffSource[addressType] = addressComponents[i][componentForm[addressType]];
    }
  }

  const address = new DeliveryAddress();

  address.addressLine1 = [dropOffSource.route, dropOffSource.street_number].filter(s => s).join(', ');

  if (!address.addressLine1) {
    address.addressLine1 = [dropOffSource.premise, dropOffSource.sublocality].filter(s => s).join(', ');
  }

  address.city = dropOffSource.locality;
  address.country = dropOffSource.country;
  address.zip = [dropOffSource.postal_code, dropOffSource.postal_code_suffix].filter(s => s).join(' ');
  address.state = dropOffSource.administrative_area_level_1;
  address.area = dropOffSource.administrative_area_level_2;
  address.geoPoint = point;

  address.formattedAddress = place['formatted_address'];

  return address;
}

export function transformErrorCode(code: string = '') {

  const codes = {
    'operation.area.not.found': i18n.pgettext('ErrorCode', 'Operation area not found'),
    'operation.not.allowed.for.order.type': i18n.pgettext('ErrorCode', 'Operation not allowed for order type'),
    'operation.not.allowed.for.order.state': i18n.pgettext('ErrorCode', 'Operation not allowed for order state'),
    'unable.to.load.service.type': i18n.pgettext('ErrorCode', 'Unable to load service type'),
    'common.object.not.exists order': i18n.pgettext('ErrorCode', 'Common object not exists order'),
    'invalid.order.state.transition': i18n.pgettext('ErrorCode', 'Invalid order state transition'),
    'drop-off.location.does.not.exist.for.order': i18n.pgettext('ErrorCode', 'Drop-off location does not exist for order'),
  };

  return codes[code] || code;
}

export function getETAmin(t: number) {
  const min = Math.round(Math.abs((Date.now() - t * 1000) / 60000));
  return min > 1 ? min : 1;
}

export const checkMobile = {
  'android': () => navigator.userAgent.match(/Android/i),
  'iOS': () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
  'other': () => !checkMobile.android() && !checkMobile.iOS()
};



// WEBPACK FOOTER //
// ./src/app/helpers.ts